module.exports = __webpack_public_path__ + "static/media/img88_R.6b7e89b8.jpg";